import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const HomePage = () => {
    return (
        <Layout>
            <div className="heading">
                <h1>ODM Self Service Portal</h1>
            </div>
            <div className="main-actions">
                <div className="action-card">
                    <Link to="/new-request" className="card-content">
                        <h2>Launch New Request</h2>
                    </Link>
                </div>
                <div className="action-card">
                    <Link to="/track-requests" className="card-content">
                        <h2>Track Existing Requests</h2>
                    </Link>
                </div>
            </div>
        </Layout>
    );
};

export default HomePage;